import { DEFAULT_BIRTHDAY_AT } from "@daytrip/legacy-config";

export function transformUserBirthdayToDate(birthdayAt?: Date) {
    return birthdayAt ?? new Date(DEFAULT_BIRTHDAY_AT);
}
